import { z } from 'zod';
import { getSiteWidgetExtensionsDir } from '@wix/cli-astro-definitions';
import { VALID_PATH_REGEX } from '../../../dev-center/components/validations/common.js';
import { createReactComponentFolderValidation } from '../../../dev-center/components/validations/react-component.js';
import type { ExtensionDef } from '../generate-schema/types.js';
import { defineField } from '../generate-schema/definitions.js';
import { generateEditorReactComponent } from './generate.js';

const schema = z.object({
  extensionType: z.literal('EDITOR_REACT_COMPONENT'),
  name: z
    .string()
    .max(30)
    .describe(defineField({ title: 'Component name' })),
  folder: z
    .string()
    .regex(VALID_PATH_REGEX)
    .describe(
      defineField({
        title: 'Component folder',
        description: 'Lowercase alphanumeric and hyphens only.',
      })
    ),
  description: z
    .string()
    .min(3)
    .max(300)
    .describe(defineField({ title: 'Component description' })),
});

export const editorReactComponent: ExtensionDef<typeof schema> = {
  title: 'Editor React Component',
  description: 'A site widget built as a React component for the Wix editor',
  group: 'Site',
  zodSchema: schema,
  validate: async (projectFolder, data) => {
    const result = createReactComponentFolderValidation(
      getSiteWidgetExtensionsDir(projectFolder)
    )(data.folder);
    return result.valid ? null : result.reason;
  },
  generate: ({ projectFolder, model, data }) =>
    generateEditorReactComponent(
      projectFolder,
      data.folder,
      data.name,
      data.description,
      model.config.projectType === 'App'
        ? model.config.codeIdentifier
        : undefined
    ),
};
